import useTranslation from "@babackapp/translations/use-translation";
import { TabsList, TabsTrigger } from "@babackapp/ui/components/tabs";
import { useFormContext } from "react-hook-form";
import { ExportSettingsFormValues } from "./export-settings-form";

export default function ExportFormTabs() {
  const {
    formState: { errors },
    trigger,
  } = useFormContext<ExportSettingsFormValues>();

  const t = useTranslation();

  return (
    <TabsList onChange={() => trigger()} className="grid grid-cols-2 mb-8">
      <TabsTrigger
        value="server"
        className={errors.server ? "text-red-500" : ""}
      >
        {t("settings.integrations.exports.addExport.tabs.destination")}
      </TabsTrigger>

      <TabsTrigger
        value="options"
        className={errors.options ? "text-red-500" : ""}
      >
        {t("settings.integrations.exports.addExport.tabs.options")}
      </TabsTrigger>
    </TabsList>
  );
}
